// extracted by mini-css-extract-plugin
export var adv = "style-module--adv--a8b5e";
export var adv__bottom = "style-module--adv__bottom--4920c";
export var adv__title = "style-module--adv__title--bd3d2";
export var adv__top = "style-module--adv__top--2d67f";